@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.today_v2.today_ui_carni.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.today_v2.today_ui_carni.generated.resources/"

@delegate:ResourceContentHash(-993_363_418)
internal val Res.drawable.ic_charm_lightning_bolt: DrawableResource by lazy {
      DrawableResource("drawable:ic_charm_lightning_bolt", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_charm_lightning_bolt.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_879_723_253)
internal val Res.drawable.ic_plus_20: DrawableResource by lazy {
      DrawableResource("drawable:ic_plus_20", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_plus_20.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_charm_lightning_bolt", Res.drawable.ic_charm_lightning_bolt)
  map.put("ic_plus_20", Res.drawable.ic_plus_20)
}
